import { Switch, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  variant: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};
const CookieFormSetting = ({ variant, onClick }: Props) => {
  switch (variant) {
    case 'always':
      return (
        <Typography color="success.600" variant="body3">
          <FormattedMessage id="cookie_banner.cookie_form.always_active" />
        </Typography>
      );

    case 'optional':
      return <Switch defaultChecked onClick={onClick} />;

    default:
      return null;
  }
};
export default CookieFormSetting;
